<template>
  <div>
    <template v-for="(group, groupIndex) in form">
      <template v-if="checkGroupShow(categories, group, form)">
        <template v-for="(field, fieldIndex) in group.fields">
          <div v-if="checkFieldShow(categories, field, form)" class="form-group row align-items-center mb-2" :pino="field.type" :key="`group-${groupIndex}-${fieldIndex}`">
            <label v-if="field.type != 'files' && field.type != 'collection'" class="col-12 col-sm-5 text-sm">
              {{ field.label }}
            </label>
            <div class="col-12 text-sm" :class="{ 'col-sm-7': field.type != 'files' && field.type != 'collection' }">
              <span v-if="field.type == 'text' || field.type == 'textarea' || field.type == 'number'">{{ field.value }} {{ field.unit }}</span>
              <span v-if="field.type == 'select'">{{ field.options[field.value] }}</span>
              <span v-if="field.type == 'flag'" style="font-size: 1.5rem">
                <i v-if="field.value" class="tio-checkmark-square-outlined"></i>
                <i v-else class="tio-square-outlined"></i>
              </span>
              <div v-if="field.type == 'files'">
                <div :id="`fancy-${groupIndex}-${fieldIndex}`" class="js-fancybox row justify-content-sm-center gx-2" :data-hs-fancybox-options="fancyBoxOptions(fieldIndex, groupIndex)">
                  <div v-for="(fileItem, fileItemIndex) in field.items" :key="fileItemIndex" class="col-sm-4 mb-3 mb-sm-0">
                    <div class="card card-sm">
                      <img class="card-img-top" :src="fileItem.url" :alt="fileItem.file_name" />
                      <div class="card-body text-center p-3">
                        <div class="row">
                          <div class="col-6">
                            <a
                              class="js-fancybox-item text-body"
                              href="javascript:;"
                              data-toggle="tooltip"
                              data-placement="top"
                              title="View"
                              :data-src="fileItem.url"
                              :data-caption="fileItem.file_name"
                            >
                              <i class="tio-visible-outlined mr-1"></i>
                            </a>
                          </div>
                          <div class="col-6">
                            <a class="text-body" href="javascript:;" data-toggle="tooltip" data-placement="top" title="Download" @click="downloadFile(fileItem)">
                              <i class="tio-download-outlined mr-1"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="field.type == 'collection'">
                <div v-for="(collectionItem, collectionItemIndex) in field.items" :key="`collection-item-${groupIndex}-${fieldIndex}-${collectionItemIndex}`" class="collection-item p-4 mb-4">
                  <template v-for="(group, groupIndex) in collectionItem">
                    <template v-if="checkGroupShow(categories, group, form)">
                      <template v-for="(field, fieldIndex) in group.fields">
                        <div
                          v-if="checkFieldShow(categories, field, form)"
                          class="form-group row align-items-center mb-2"
                          :pino="field.type"
                          :key="`group-${groupIndex}-${fieldIndex}-${collectionItemIndex}`"
                        >
                          <label v-if="field.type != 'files'" class="col-12 col-sm-5 text-sm">
                            {{ field.label }}
                          </label>
                          <div class="col-12 text-sm" :class="{ 'col-sm-7': field.type != 'files' }">
                            <span v-if="field.type == 'text' || field.type == 'textarea' || field.type == 'number'">{{ field.value }} {{ field.unit }}</span>
                            <span v-if="field.type == 'select'">{{ field.options[field.value] }}</span>
                            <span v-if="field.type == 'flag'" style="font-size: 1.5rem">
                              <i v-if="field.value" class="tio-checkmark-square-outlined"></i>
                              <i v-else class="tio-square-outlined"></i>
                            </span>
                            <div v-if="field.type == 'files'">
                              <div :id="`fancy-${groupIndex}-${fieldIndex}`" class="js-fancybox row justify-content-sm-center gx-2" :data-hs-fancybox-options="fancyBoxOptions(fieldIndex, groupIndex)">
                                <div v-for="(fileItem, fileItemIndex) in field.items" :key="fileItemIndex" class="col-sm-4 mb-3 mb-sm-0">
                                  <div class="card card-sm">
                                    <img class="card-img-top" :src="fileItem.url" :alt="fileItem.file_name" />
                                    <div class="card-body text-center p-3">
                                      <div class="row">
                                        <div class="col-6">
                                          <a
                                            class="js-fancybox-item text-body"
                                            href="javascript:;"
                                            data-toggle="tooltip"
                                            data-placement="top"
                                            title="View"
                                            :data-src="fileItem.url"
                                            :data-caption="fileItem.file_name"
                                          >
                                            <i class="tio-visible-outlined mr-1"></i>
                                          </a>
                                        </div>
                                        <div class="col-6">
                                          <a class="text-body" href="javascript:;" data-toggle="tooltip" data-placement="top" title="Download" @click="downloadFile(fileItem)">
                                            <i class="tio-download-outlined mr-1"></i>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import { checkGroupShow, checkFieldShow, checkFieldDisable, findFieldByKey, findFieldInFormByKey, checkCondition } from "../helpers";
export default {
  props: ["categories", "form"],

  mounted() {
    $(".js-fancybox").each(function () {
      $.HSCore.components.HSFancyBox.init($(this));
    });
  },

  methods: {
    checkGroupShow: checkGroupShow,
    checkFieldShow: checkFieldShow,
    checkFieldDisable: checkFieldDisable,
    findFieldByKey: findFieldByKey,
    findFieldInFormByKey: findFieldInFormByKey,
    checkCondition: checkCondition,

    fancyBoxOptions(fieldIndex, groupIndex) {
      return `{ "selector": "#fancy-${groupIndex}-${fieldIndex} .js-fancybox-item" }`;
    },

    downloadFile(file) {
      window.open(route("download_media", file.media_id), "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.collection-item {
    border-radius: 6px;
    border: 1px dashed var(--gray);
}
</style>
